var map = {
	"./Argentina.png": "0157",
	"./Australia.png": "1c5d",
	"./Belarus.png": "bbe0",
	"./Bolivia.png": "dafc",
	"./Brazil.png": "3c9f",
	"./Canada.png": "e7dc",
	"./Chile.png": "025f",
	"./Colombia.png": "4f9a4",
	"./CostaRica.png": "dfa2",
	"./France.png": "d2b3",
	"./Hungary.png": "764a",
	"./Ireland.png": "3e4d",
	"./Italy.png": "6f95",
	"./Kazakhstan.png": "8dab",
	"./Latvia.png": "d1e9",
	"./Lithuania.png": "a724",
	"./Mexico.png": "2da6",
	"./Mongolia.png": "7a3e",
	"./Namibia.png": "27f2",
	"./Netherlands.png": "23c1",
	"./NewZealand.png": "ecd0",
	"./Nicaragua.png": "26db",
	"./Panama.png": "0763",
	"./Poland.png": "a6fe",
	"./PorkArgentina.png": "45d6",
	"./PorkAustria.png": "9c0a",
	"./PorkBrazil.png": "dea9",
	"./PorkCanada.png": "611f",
	"./PorkChile.png": "369a",
	"./PorkCostaRica.png": "9126",
	"./PorkDenmark.png": "c827",
	"./PorkFinland.png": "a304",
	"./PorkFrance.png": "a9f7",
	"./PorkGermany.png": "57ab",
	"./PorkIreland.png": "28e1",
	"./PorkItaly.png": "7aa9",
	"./PorkMexico.png": "de0c",
	"./PorkNetherlands.png": "a03f",
	"./PorkPortugal.png": "5f52",
	"./PorkSpain.png": "e6bf",
	"./PorkSwitzerland.png": "f4ca",
	"./PorkTheUnitedKingdom.png": "2573",
	"./PorkTheUnitedStates.png": "5d78",
	"./Russia.png": "c1a2",
	"./Serbia.png": "0684",
	"./SouthAfrica.png": "a411",
	"./TheUnitedKingdom.png": "a1bb",
	"./TheUnitedStates.png": "83e6",
	"./Ukraine.png": "a03d",
	"./Uruguay.png": "5254"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8b5d";